import { formatNumber } from './formatNumber';
import { isNumber } from './isNumber';

import { FRACTION_LENGTH } from '../constants';

export function formatDecimal(input, options = {}) {
  if (isNumber(options)) options = { fractionLength: options };
  return formatNumber(input, { fractionLength: FRACTION_LENGTH, ...options });
}
